import React from "react";

export default function Banner() {
  return (
    <section className="page-header" id="about-header">
      <h2>#KnowMore</h2>
      <p>Blog here</p>
    </section>
  );
}
